export const tabsKeys = {
  PROFILE: 'profile',
  SEND_GIFT: 'send-gift',
  HISTORY: 'history',
  BULK_CREATE_CONTACTS: 'bulk-create-contacts',
};
